<template>
    <div class="commodity-content">
        <div class="commodity-title">
            <el-date-picker
                v-model="value2"
                v-show="isFull == false"
                type="month"
                placeholder="选择月"
                size="mini"
                style="width: 150px"
                value-format="yyyy-MM"
                format="yyyy-MM"
                @change="changeTap"
            >
            </el-date-picker>
            <el-date-picker
                v-show="isFull == true"
                v-model="value2"
                :append-to-body="false"
                type="month"
                placeholder="选择月"
                size="mini"
                style="width: 150px"
                value-format="yyyy-MM"
                format="yyyy-MM"
                @change="changeTap"
            >
            </el-date-picker>
        </div>
        <div class="weekBox">
        <div class="weekTop">
          <P class="weekItem">序号</P>
          <P class="weekItem">姓名</P>
          <P class="weekItem">次数</P>
        </div>
        <div style="height: 160px; overflow-y: auto">
          <div class="weekTops" v-for="(item, index) in list" :key="index" @click="personInfo(item)">
            <P class="weekItem">{{ Number(index) + 1 }}</P>
            <!-- <P class="weekItem">{{ item.name }}</P> -->
            <P class="weekItem">{{ item.waresName }}</P>
            <P class="weekItem">{{ item.monthSum }}</P>
            <!-- <P class="weekItem">{{ item.monthSum }}</P> -->
          </div>
        </div>
      </div>
        <!-- <div class="aaaaaa">
            <div v-for="(item, index) in list" :key="index" class="team-list">
                <div :style="{ background: item.backcolor, color: item.color }">
                    {{ index + 1 }}
                </div>
                <div style="color: #dadcde;">{{ item.waresName }}</div>
                <div :style="{ color: item.backcolor }">
                    {{ item.monthSum }}
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        return {
            value2: "",
            list: [
            //     {
            //       waresName:"护身符",
            //       monthSum:"4"
            //     },
            //     {
            //       waresName:"粽子",
            //       monthSum:"8"
            //     },
            //     {
            //       waresName:"精致小礼品",
            //       monthSum:"8"
            //     },
            ],
        }
    },
    computed: {
        isFull() {
            this.$forceUpdate()
            // console.log(this.$store.state.isFull, "状态")
            return this.$store.state.isFull
        },
    },
    watch: {
        // isFull(val, val1) {
        //     // this.$forceUpdate()
        //     console.log(val, val1, "计算状态")
        // },
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 日期修改
        changeTap(val) {
            if (val) {
                this.value2 = val + "-01"
            }

            this.getList()
        },
        // 列表
        getList() {
            request({
                url: "/sqyl/admin/wares/info/findByWaresExchange",
                method: "POST",
                data: {
                    exchangeDate: this.value2 == "" ? null : this.value2,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        res.content.forEach((item, index) => {
                            if (index == 0) {
                                item.backcolor = "#fffa61"
                                item.color = "#333333"
                            } else if (index == 1) {
                                item.backcolor = "#eeeeee"
                                item.color = "#333333"
                            } else if (index == 2) {
                                item.backcolor = "#e9c569"
                                item.color = "#333333"
                            } else {
                                item.backcolor = "#1999f7"
                                item.backcolor = "#ffffff"
                            }
                        })
                        this.list = res.content
                    } else {
                        this.list = []
                    }
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.commodity-content {
    width: 400px;
    height: 22vh;
    overflow: hidden;
}
.aaaaaa {
    height: 14vh;
    overflow-y: auto;
}
.commodity-title {
    width: 95%;
    margin: 20px auto;

    /deep/ .el-input__inner {
        background-color: #fff0;
        border: 1px solid #2e48a0;
        color: #29dce3;
    }
}

.team-list {
    width: 92%;
    display: flex;
    margin: 15px auto;
    font-size: 14px;
}

.team-list > div:first-child {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    line-height: 20px;
    text-align: center;
    margin-right: 10px;
}

.team-list > div:nth-child(2) {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.weekBox{
    width: 100%;
   .weekTop {
        margin-top:10px; 
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        line-height: 30px;
        justify-content: center;
    }
    .weekTops {
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        line-height: 25px;
        justify-content: center;
    }
 .weekEats {
    height: 72px;
    .weekEat {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 24px;
      color: #fff;
      height: 24px;
      font-size: 12px;
    }
  }
  .typeName {
    width: 60px;
    position: relative;
    text-align: center;
    font-size: 12px !important;
    color: #fff !important;
  }
  .weekItem {
    flex: 1;
    font-size: 12px !important;
    color: #fff !important;
    width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
